import { Card, CardContent, Grid2, ListItemIcon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { JSX } from "react/jsx-runtime";
import { Heading } from "../../shared/ReusableComponents";

interface ICardItemProps {
  title: string;
  description: string;
  icon: JSX.Element;
  bgColor: string;
  iconColor: string;
  textColor: string;
  navigateTo: string;
}

export const CardItem: React.FC<ICardItemProps> = ({
  title,
  description,
  icon,
  bgColor,
  iconColor,
  textColor,
  navigateTo,
}) => {
  const navigate = useNavigate();
  const handleCardClick = () => {
    navigate(navigateTo);
  };
  return (
    <Grid2 size={{ xs: 12, sm: 6 }} padding="10px">
      <Card
        data-testid="card-item"
        onClick={handleCardClick}
        sx={{
          height: "80px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: "8px",
          padding: "16px",
          backgroundColor: bgColor,
          cursor: "pointer",
          boxShadow: "none",
        }}
      >
        <CardContent sx={{ padding: "24px 0px 24px 34px" }}>
          <Heading text={title} type="h4" isBold={true} color={textColor} />
          <Heading
            text={description}
            font="1rem"
            isBold={false}
            style={{ marginTop: "6px" }}
          />
        </CardContent>
        <ListItemIcon className="fs-60" sx={{ color: iconColor, mr: "20px" }}>
          {icon}
        </ListItemIcon>
      </Card>
    </Grid2>
  );
};
